import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';


@Directive({
  selector: '[href]',
  host: { '(click)': 'preventDefault($event)' },
})
export class HrefPreventDefaultDirective implements AfterViewInit {
  @Input() href: string;

  constructor(private el: ElementRef) {

  }
  ngAfterViewInit() {

  }
  preventDefault(event) {
    if (this.href.length === 0 || this.href === '#') {
      event.preventDefault();
    }
  }

}



// WEBPACK FOOTER //
// E:/GangaJewallery-Final/app.server/systemic.app.server/client/src/main/@systemic/directives/control/href-prevent-default.ts